goog.declareModuleId('yext.m4.confcode.adminconsole.modal.HelpModal');

import {SmallDialog} from '/ui/components/modal/dialog';
goog.require('yext');

/**
 * @fileoverview Component that renders the help modal.
 *
 * @author Alan Yan (ayan@yext.com)
 */

/**
 * @return {React.ReactNode}
 */
export function HelpModal(props) {
  const [showDialog, setShowDialog] = React.useState(props.showDialog);

  // When prop refs are changed, it implies that the modal has been invoked
  // again with a new set of props. In this case refresh the states.
  React.useEffect(() => {
    setShowDialog(true);
  }, [props]);

  return <SmallDialog
    title="Help"
    show={showDialog}
    onHideDialog={() => setShowDialog(false)}
  >
    <p>{
      yext.msg('AdminConsole helps you interact with your account configuration as code. ' +
          'You can either pull an account or a GitHub URL. ')
    }</p>
    <p>{
      yext.msg('Filter to a subset of resources with URL query parameters. ') +
        yext.msg('For example, "/resources?sourceAccountId=123&type=km/entity&name="myEntity" will only return entity resources named "myEntity". ')
    }</p>
    <p>{
      yext.msg('For more details, please check the ')
    }
    <a href="https://hitchhikers.yext.com/tracks/solution-templates/sol202-introduction-to-the-admin-console/01-what-is-the-admin-console/"
      rel="noreferrer" target="_blank">
          Hitchhikers Admin Console Module
    </a>
    </p>
  </SmallDialog>;
}
